import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getDuckyByRegion } from "../../selectors/widget.js";
import Block from "../Block";
import { round } from "lodash";

const Graph = ({ module }) => {
  const { cityIndex, county } = module;
  const [mergedOptions, setMergedOptions] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState({ label: "Kommune", value: "municipality" });
  const [selectedType, setSelectedType] = useState({ label: "Oversikt", value: "general" });
  const [typeOptions] = useState([
    { label: "Oversikt", value: "general" },
    { label: "Mat og drikke", value: "food" },
  ]);
  const [seriesOptions] = useState([
    { label: "Kommune", value: "municipality" },
    { label: "Fylke", value: "county" },
  ]);

  const [apiDataset, setApiDataset] = useState(null);
  const [filteredDataset, setFilteredDataset] = useState(null);
  const apiResult = useSelector((state) => getDuckyByRegion(state, "Sørøst"));

  useEffect(() => {
    if (apiResult && selectedType) {
      let apiResultData = apiResult.filter((x) => x.type === selectedType.value);
      setApiDataset(apiResultData[0].data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResult, selectedType]);

  useEffect(() => {
    if (apiDataset && selectedSeries) {
      //let apiResultData = [];
      // if (selectedSeries.value === "municipality") {
      //   apiResultData = apiDataset.filter((x) => x.areaId.length === 4);
      // }
      // if (selectedSeries.value === "county") {
      //   apiResultData = apiDataset.filter((x) => x.areaId.length === 2);
      // }
      let sorted = apiDataset.sort((a, b) => (a.totalCo2Kg > b.totalCo2Kg ? 1 : -1));

      setFilteredDataset(sorted);
    }
  }, [apiDataset, selectedSeries]);

  useEffect(() => {
    if (!selectedType && typeOptions && apiDataset) {
      setSelectedType(typeOptions[0]);
    }
  }, [selectedType, typeOptions, apiDataset]);
  useEffect(() => {
    if (!selectedSeries && seriesOptions && apiDataset) {
      setSelectedSeries(typeOptions[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeries, seriesOptions, apiDataset]);

  useEffect(() => {
    if (filteredDataset) {
      let data = filteredDataset;
      let labels = data.map((item) => {
        if (item.areaId === cityIndex.toString() || item.areaId === county || item.areaId === "0") {
          return {
            value: item.name,
            textStyle: { fontWeight: "bolder", color: "black", fontSize: "15" },
          };
        }
        return { value: item.name };
      });

      let seriesData = {
        type: "bar",
        barGap: 0,
        data: data.map((item) => {
          if (item.areaId === cityIndex.toString() || item.areaId === county || item.areaId === "0") {
            return {
              name: item.name,
              value: round(item.totalCo2Kg / 1000, 2),
              co2: item.totalCo2Kg,
              itemStyle: { color: "#70c7aa" },
            };
          }
          return { name: item.name, value: round(item.totalCo2Kg / 1000, 2) };
        }),
        label: {
          show: true,
          rotate: 0,
          formatter: function (params) {
            return `${params.value.toLocaleString("nb-NO")}`;
          },
        },
        emphasis: {
          focus: "series",
        },
      };
      let nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "axis",
          order: "valueDesc",
          formatter: function (params) {
            let tooltip = `${params[0].axisValue} <br/>`;
            params.forEach((item) => {
              tooltip += `${item.marker} ${round(item.value, 2).toLocaleString("nb-NO") + " tonn CO₂e"} </br>`;
            });
            return tooltip;
          },
        },

        yAxis: {
          type: "category",
          data: labels,
          axisLabel: {
            interval: 0,
            rotate: 0, //If the label names are too long you can manage this by rotating the label.
          },
        },
        xAxis: {
          type: "value",
          name: "CO₂e",
          axisLabel: {
            formatter: function (value) {
              return value + " tonn";
            },
          },
        },
        series: seriesData,
      };

      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredDataset]);

  if (mergedOptions) {
    return (
      <Block>
        <div className="selectbox">
          {/* {selectedSeries && (
            <div className="col-lg-6">
              <Select
                options={seriesOptions}
                defaultValue={seriesOptions[0]}
                onChange={(d) => {
                  setSelectedSeries(d);
                }}
                value={selectedSeries}
              />
            </div>
          )} */}
          {/* {selectedType && (
            <div className="col-lg-6">
              <Select
                options={typeOptions}
                defaultValue={typeOptions[0]}
                onChange={(d) => {
                  setSelectedType(d);
                }}
                value={selectedType}
              />
            </div>
          )} */}
        </div>

        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "600px" }} notMerge={true} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 10, right: 45, bottom: 2, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  series: null,
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});

// const parseOptions = (options) => {
//   return options.map((option) => Object.assign({}, { label: option.name, value: option.areaId }));
// };
